import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const EmailTemplate = Loadable(lazy(() => import('./emailTemplate')));
const TemplateCreatePage = Loadable(lazy(() => import('./TemplateCreatePage')));
const TemplateViewPage = Loadable(lazy(() => import('./TemplateViewPage')));
const TemplateEditPage = Loadable(lazy(() => import('./TemplateEditPage')));

const emailTemplatesRoutes = [
  { path: '/dashboard/email-templates', element: <EmailTemplate />, auth: authRoles.admin },
  { path: '/dashboard/email-templates/new', element: <TemplateCreatePage />, auth: authRoles.admin },
  { path: '/dashboard/email-templates/:id/edit', element: <TemplateEditPage />, auth: authRoles.admin },
  { path: '/dashboard/email-templates/:id', element: <TemplateViewPage />, auth: authRoles.admin },
];

export default emailTemplatesRoutes;
